import React, { Component } from 'react';
import { images } from '../asset/image'
import i18next from '../global/LocalizedStrings'
import './ChartButton.css';


export class ChartButton extends Component {

    componentDidMount() {

    }

    render() {
        const { title, theme, onClick } = this.props
        let imageKey = (title + '_' + theme.themeName).toLowerCase().replace(' ', '')

        if (title === 'stop') {
            imageKey = 'stop'
        }

        if (title === 'sell' || title === 'corver') {
            imageKey = 'stop_deal'
        }

        return (
            <div className="container" onClick={() => { onClick(title) }}>
                <img src={images[imageKey]} className="button-image" />
                <div style={{ marginTop: -20 }}>
                    <span className="button-text" style={{ color: theme.textColor }}>{i18next.t(title)}</span>
                </div>
            </div>
        );
    }
}
